import React, { useEffect, useState } from "react";

// Pantalla de inicio ZAVIA: solo el icono animado, dura máx. 2 segundos.
export default function LogoSplash() {
  const [show, setShow] = useState(true);
  useEffect(() => { const t = setTimeout(() => setShow(false), 2000); return () => clearTimeout(t); }, []);
  if (!show) return null;
  return (
    <div data-testid="logo-splash" aria-hidden="true" className="zv-splash fixed inset-0 z-[9999] flex items-center justify-center bg-white">
      <style>{`
        .zv-splash{animation:zvOut .35s ease 1.65s forwards}
        .zv-wrap{position:relative;width:132px;height:112px;animation:zvIn .75s cubic-bezier(.2,1.4,.4,1) both, zvFloat 1s ease-in-out .75s infinite alternate}
        .zv-wrap img{width:100%;height:100%;object-fit:contain;filter:drop-shadow(0 12px 24px rgba(10,108,255,.35))}
        .zv-shine{position:absolute;inset:0;-webkit-mask:url(/zavia-icon.png) center/contain no-repeat;mask:url(/zavia-icon.png) center/contain no-repeat;
          background:linear-gradient(110deg,transparent 35%,rgba(255,255,255,.85) 50%,transparent 65%);background-size:250% 100%;animation:zvShine 1.1s ease .55s 1 both}
        .zv-ring{position:absolute;width:210px;height:210px;border-radius:50%;border:3px solid rgba(10,108,255,.15);border-top-color:#0A6CFF;animation:zvSpin .9s linear infinite, zvRing .5s ease both}
        .zv-pulse{position:absolute;width:150px;height:150px;border-radius:50%;background:radial-gradient(circle,rgba(10,124,255,.18),transparent 70%);animation:zvPulse 1.2s ease-out .3s infinite}
        @keyframes zvIn{0%{opacity:0;transform:scale(.3) rotate(-25deg);filter:blur(8px)}100%{opacity:1;transform:scale(1) rotate(0);filter:blur(0)}}
        @keyframes zvFloat{to{transform:translateY(-6px) scale(1.03)}}
        @keyframes zvShine{0%{background-position:150% 0}100%{background-position:-100% 0}}
        @keyframes zvSpin{to{transform:rotate(360deg)}}
        @keyframes zvRing{from{opacity:0;transform:scale(.6)}}
        @keyframes zvPulse{0%{transform:scale(.6);opacity:1}100%{transform:scale(1.9);opacity:0}}
        @keyframes zvOut{to{opacity:0;transform:scale(1.08);visibility:hidden}}
      `}</style>
      <div className="zv-pulse" />
      <div className="zv-ring" />
      <div className="zv-wrap"><img src="/zavia-icon.png" alt="" /><div className="zv-shine" /></div>
    </div>
  );
}
